export const AdminHome404NotFound = () => {
	return (<div></div>);
}